/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelFromJSONTyped,
    BasicModelToJSON,
} from './BasicModel';
import {
    MachineDocumentViewModel,
    MachineDocumentViewModelFromJSON,
    MachineDocumentViewModelFromJSONTyped,
    MachineDocumentViewModelToJSON,
} from './MachineDocumentViewModel';
import {
    MachineRentalDetailModel,
    MachineRentalDetailModelFromJSON,
    MachineRentalDetailModelFromJSONTyped,
    MachineRentalDetailModelToJSON,
} from './MachineRentalDetailModel';
import {
    MachineRentalTypeModel,
    MachineRentalTypeModelFromJSON,
    MachineRentalTypeModelFromJSONTyped,
    MachineRentalTypeModelToJSON,
} from './MachineRentalTypeModel';
import {
    MachineSaleDetailModel,
    MachineSaleDetailModelFromJSON,
    MachineSaleDetailModelFromJSONTyped,
    MachineSaleDetailModelToJSON,
} from './MachineSaleDetailModel';
import {
    SubCategoryModel,
    SubCategoryModelFromJSON,
    SubCategoryModelFromJSONTyped,
    SubCategoryModelToJSON,
} from './SubCategoryModel';

/**
 * 
 * @export
 * @interface MachineDetailModel
 */
export interface MachineDetailModel {
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    id?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    lessorCompanyId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    subCategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    brandId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    brandOther?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    modelName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    productionYear?: number;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operationMileage?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operationHour?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    drivingEquipment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    enginePower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operatingWeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    tankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    fuelTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    elevatorTypeId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operatingHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operatingArea?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operatingLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operationWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operatingCapacity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    usageFields?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    hasCabin?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    engineBrand?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    hasPlatform?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    hasTowerElevationSystem?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    lightningCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    carryingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    width?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    volume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    height?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    floorCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    liftingHeight?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    notes?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    saleNotes?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    hasOperator?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    operatorExperienceYear?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    shipingIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    operatorCostIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    operatorInsuranceIncluded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    isApproved?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    isApprovedForSale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    isMachineRemovedFromSale?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    fuelIncluded?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof MachineDetailModel
     */
    creationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MachineDetailModel
     */
    modifiedDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    createdUserId?: number;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    createdUserRole?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    bladeWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    frequency?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    minPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxPower?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxLoadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    nominalCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    waterTankCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxFeedingSize?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    workingSpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    cleaningCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    garbageCollectionBin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    breakingInfo?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    bomLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxHeight?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxDepth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    compressionWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    platformLength?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    platformWidth?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    concretePumpingCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    maxPressure?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    freeAirOutput?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    spraySpeed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    tankVolume?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    loadCapacity?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    cameraResolutionId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    flightTime?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    flightDistance?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    workingRadius?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MachineDetailModel
     */
    isMachineForSale?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    machineSalePrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    machineSalePriceCurrencyId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MachineDetailModel
     */
    machineLocationCityId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    rentalAdTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MachineDetailModel
     */
    saleAdTitle?: string | null;
    /**
     * 
     * @type {BasicModel}
     * @memberof MachineDetailModel
     */
    lessorCompany?: BasicModel;
    /**
     * 
     * @type {SubCategoryModel}
     * @memberof MachineDetailModel
     */
    subCategory?: SubCategoryModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof MachineDetailModel
     */
    brand?: BasicModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof MachineDetailModel
     */
    fuelType?: BasicModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof MachineDetailModel
     */
    elevatorType?: BasicModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof MachineDetailModel
     */
    cameraResolution?: BasicModel;
    /**
     * 
     * @type {BasicModel}
     * @memberof MachineDetailModel
     */
    machineLocationCity?: BasicModel;
    /**
     * 
     * @type {MachineSaleDetailModel}
     * @memberof MachineDetailModel
     */
    machineSaleDetail?: MachineSaleDetailModel;
    /**
     * 
     * @type {MachineRentalDetailModel}
     * @memberof MachineDetailModel
     */
    machineRentalDetail?: MachineRentalDetailModel;
    /**
     * 
     * @type {Array<MachineRentalTypeModel>}
     * @memberof MachineDetailModel
     */
    rentalTypes?: Array<MachineRentalTypeModel> | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof MachineDetailModel
     */
    serviceRegions?: Array<BasicModel> | null;
    /**
     * 
     * @type {Array<MachineDocumentViewModel>}
     * @memberof MachineDetailModel
     */
    documents?: Array<MachineDocumentViewModel> | null;
    /**
     * 
     * @type {Array<BasicModel>}
     * @memberof MachineDetailModel
     */
    attachments?: Array<BasicModel> | null;
}

export function MachineDetailModelFromJSON(json: any): MachineDetailModel {
    return MachineDetailModelFromJSONTyped(json, false);
}

export function MachineDetailModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineDetailModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'lessorCompanyId': !exists(json, 'lessorCompanyId') ? undefined : json['lessorCompanyId'],
        'subCategoryId': !exists(json, 'subCategoryId') ? undefined : json['subCategoryId'],
        'brandId': !exists(json, 'brandId') ? undefined : json['brandId'],
        'brandOther': !exists(json, 'brandOther') ? undefined : json['brandOther'],
        'modelName': !exists(json, 'modelName') ? undefined : json['modelName'],
        'productionYear': !exists(json, 'productionYear') ? undefined : json['productionYear'],
        'operationMileage': !exists(json, 'operationMileage') ? undefined : json['operationMileage'],
        'operationHour': !exists(json, 'operationHour') ? undefined : json['operationHour'],
        'drivingEquipment': !exists(json, 'drivingEquipment') ? undefined : json['drivingEquipment'],
        'enginePower': !exists(json, 'enginePower') ? undefined : json['enginePower'],
        'operatingWeight': !exists(json, 'operatingWeight') ? undefined : json['operatingWeight'],
        'tankCapacity': !exists(json, 'tankCapacity') ? undefined : json['tankCapacity'],
        'fuelTypeId': !exists(json, 'fuelTypeId') ? undefined : json['fuelTypeId'],
        'elevatorTypeId': !exists(json, 'elevatorTypeId') ? undefined : json['elevatorTypeId'],
        'operatingHeight': !exists(json, 'operatingHeight') ? undefined : json['operatingHeight'],
        'operatingArea': !exists(json, 'operatingArea') ? undefined : json['operatingArea'],
        'operatingLength': !exists(json, 'operatingLength') ? undefined : json['operatingLength'],
        'operationWidth': !exists(json, 'operationWidth') ? undefined : json['operationWidth'],
        'operatingCapacity': !exists(json, 'operatingCapacity') ? undefined : json['operatingCapacity'],
        'usageFields': !exists(json, 'usageFields') ? undefined : json['usageFields'],
        'hasCabin': !exists(json, 'hasCabin') ? undefined : json['hasCabin'],
        'engineBrand': !exists(json, 'engineBrand') ? undefined : json['engineBrand'],
        'hasPlatform': !exists(json, 'hasPlatform') ? undefined : json['hasPlatform'],
        'hasTowerElevationSystem': !exists(json, 'hasTowerElevationSystem') ? undefined : json['hasTowerElevationSystem'],
        'lightningCapacity': !exists(json, 'lightningCapacity') ? undefined : json['lightningCapacity'],
        'carryingCapacity': !exists(json, 'carryingCapacity') ? undefined : json['carryingCapacity'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'volume': !exists(json, 'volume') ? undefined : json['volume'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'floorCount': !exists(json, 'floorCount') ? undefined : json['floorCount'],
        'liftingHeight': !exists(json, 'liftingHeight') ? undefined : json['liftingHeight'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'saleNotes': !exists(json, 'saleNotes') ? undefined : json['saleNotes'],
        'hasOperator': !exists(json, 'hasOperator') ? undefined : json['hasOperator'],
        'operatorExperienceYear': !exists(json, 'operatorExperienceYear') ? undefined : json['operatorExperienceYear'],
        'shipingIncluded': !exists(json, 'shipingIncluded') ? undefined : json['shipingIncluded'],
        'operatorCostIncluded': !exists(json, 'operatorCostIncluded') ? undefined : json['operatorCostIncluded'],
        'operatorInsuranceIncluded': !exists(json, 'operatorInsuranceIncluded') ? undefined : json['operatorInsuranceIncluded'],
        'isApproved': !exists(json, 'isApproved') ? undefined : json['isApproved'],
        'isApprovedForSale': !exists(json, 'isApprovedForSale') ? undefined : json['isApprovedForSale'],
        'isMachineRemovedFromSale': !exists(json, 'isMachineRemovedFromSale') ? undefined : json['isMachineRemovedFromSale'],
        'fuelIncluded': !exists(json, 'fuelIncluded') ? undefined : json['fuelIncluded'],
        'creationDate': !exists(json, 'creationDate') ? undefined : (new Date(json['creationDate'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (new Date(json['modifiedDate'])),
        'createdUserId': !exists(json, 'createdUserId') ? undefined : json['createdUserId'],
        'createdUserRole': !exists(json, 'createdUserRole') ? undefined : json['createdUserRole'],
        'bladeWidth': !exists(json, 'bladeWidth') ? undefined : json['bladeWidth'],
        'frequency': !exists(json, 'frequency') ? undefined : json['frequency'],
        'minPower': !exists(json, 'minPower') ? undefined : json['minPower'],
        'maxPower': !exists(json, 'maxPower') ? undefined : json['maxPower'],
        'maxLoadCapacity': !exists(json, 'maxLoadCapacity') ? undefined : json['maxLoadCapacity'],
        'nominalCapacity': !exists(json, 'nominalCapacity') ? undefined : json['nominalCapacity'],
        'waterTankCapacity': !exists(json, 'waterTankCapacity') ? undefined : json['waterTankCapacity'],
        'maxFeedingSize': !exists(json, 'maxFeedingSize') ? undefined : json['maxFeedingSize'],
        'workingSpeed': !exists(json, 'workingSpeed') ? undefined : json['workingSpeed'],
        'cleaningCapacity': !exists(json, 'cleaningCapacity') ? undefined : json['cleaningCapacity'],
        'garbageCollectionBin': !exists(json, 'garbageCollectionBin') ? undefined : json['garbageCollectionBin'],
        'breakingInfo': !exists(json, 'breakingInfo') ? undefined : json['breakingInfo'],
        'bomLength': !exists(json, 'bomLength') ? undefined : json['bomLength'],
        'maxHeight': !exists(json, 'maxHeight') ? undefined : json['maxHeight'],
        'maxDepth': !exists(json, 'maxDepth') ? undefined : json['maxDepth'],
        'maxWidth': !exists(json, 'maxWidth') ? undefined : json['maxWidth'],
        'compressionWidth': !exists(json, 'compressionWidth') ? undefined : json['compressionWidth'],
        'platformLength': !exists(json, 'platformLength') ? undefined : json['platformLength'],
        'platformWidth': !exists(json, 'platformWidth') ? undefined : json['platformWidth'],
        'concretePumpingCapacity': !exists(json, 'concretePumpingCapacity') ? undefined : json['concretePumpingCapacity'],
        'maxPressure': !exists(json, 'maxPressure') ? undefined : json['maxPressure'],
        'freeAirOutput': !exists(json, 'freeAirOutput') ? undefined : json['freeAirOutput'],
        'spraySpeed': !exists(json, 'spraySpeed') ? undefined : json['spraySpeed'],
        'tankVolume': !exists(json, 'tankVolume') ? undefined : json['tankVolume'],
        'loadCapacity': !exists(json, 'loadCapacity') ? undefined : json['loadCapacity'],
        'cameraResolutionId': !exists(json, 'cameraResolutionId') ? undefined : json['cameraResolutionId'],
        'flightTime': !exists(json, 'flightTime') ? undefined : json['flightTime'],
        'flightDistance': !exists(json, 'flightDistance') ? undefined : json['flightDistance'],
        'workingRadius': !exists(json, 'workingRadius') ? undefined : json['workingRadius'],
        'isMachineForSale': !exists(json, 'isMachineForSale') ? undefined : json['isMachineForSale'],
        'machineSalePrice': !exists(json, 'machineSalePrice') ? undefined : json['machineSalePrice'],
        'machineSalePriceCurrencyId': !exists(json, 'machineSalePriceCurrencyId') ? undefined : json['machineSalePriceCurrencyId'],
        'machineLocationCityId': !exists(json, 'machineLocationCityId') ? undefined : json['machineLocationCityId'],
        'rentalAdTitle': !exists(json, 'rentalAdTitle') ? undefined : json['rentalAdTitle'],
        'saleAdTitle': !exists(json, 'saleAdTitle') ? undefined : json['saleAdTitle'],
        'lessorCompany': !exists(json, 'lessorCompany') ? undefined : BasicModelFromJSON(json['lessorCompany']),
        'subCategory': !exists(json, 'subCategory') ? undefined : SubCategoryModelFromJSON(json['subCategory']),
        'brand': !exists(json, 'brand') ? undefined : BasicModelFromJSON(json['brand']),
        'fuelType': !exists(json, 'fuelType') ? undefined : BasicModelFromJSON(json['fuelType']),
        'elevatorType': !exists(json, 'elevatorType') ? undefined : BasicModelFromJSON(json['elevatorType']),
        'cameraResolution': !exists(json, 'cameraResolution') ? undefined : BasicModelFromJSON(json['cameraResolution']),
        'machineLocationCity': !exists(json, 'machineLocationCity') ? undefined : BasicModelFromJSON(json['machineLocationCity']),
        'machineSaleDetail': !exists(json, 'machineSaleDetail') ? undefined : MachineSaleDetailModelFromJSON(json['machineSaleDetail']),
        'machineRentalDetail': !exists(json, 'machineRentalDetail') ? undefined : MachineRentalDetailModelFromJSON(json['machineRentalDetail']),
        'rentalTypes': !exists(json, 'rentalTypes') ? undefined : (json['rentalTypes'] === null ? null : (json['rentalTypes'] as Array<any>).map(MachineRentalTypeModelFromJSON)),
        'serviceRegions': !exists(json, 'serviceRegions') ? undefined : (json['serviceRegions'] === null ? null : (json['serviceRegions'] as Array<any>).map(BasicModelFromJSON)),
        'documents': !exists(json, 'documents') ? undefined : (json['documents'] === null ? null : (json['documents'] as Array<any>).map(MachineDocumentViewModelFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(BasicModelFromJSON)),
    };
}

export function MachineDetailModelToJSON(value?: MachineDetailModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'lessorCompanyId': value.lessorCompanyId,
        'subCategoryId': value.subCategoryId,
        'brandId': value.brandId,
        'brandOther': value.brandOther,
        'modelName': value.modelName,
        'productionYear': value.productionYear,
        'operationMileage': value.operationMileage,
        'operationHour': value.operationHour,
        'drivingEquipment': value.drivingEquipment,
        'enginePower': value.enginePower,
        'operatingWeight': value.operatingWeight,
        'tankCapacity': value.tankCapacity,
        'fuelTypeId': value.fuelTypeId,
        'elevatorTypeId': value.elevatorTypeId,
        'operatingHeight': value.operatingHeight,
        'operatingArea': value.operatingArea,
        'operatingLength': value.operatingLength,
        'operationWidth': value.operationWidth,
        'operatingCapacity': value.operatingCapacity,
        'usageFields': value.usageFields,
        'hasCabin': value.hasCabin,
        'engineBrand': value.engineBrand,
        'hasPlatform': value.hasPlatform,
        'hasTowerElevationSystem': value.hasTowerElevationSystem,
        'lightningCapacity': value.lightningCapacity,
        'carryingCapacity': value.carryingCapacity,
        'width': value.width,
        'volume': value.volume,
        'height': value.height,
        'floorCount': value.floorCount,
        'liftingHeight': value.liftingHeight,
        'notes': value.notes,
        'saleNotes': value.saleNotes,
        'hasOperator': value.hasOperator,
        'operatorExperienceYear': value.operatorExperienceYear,
        'shipingIncluded': value.shipingIncluded,
        'operatorCostIncluded': value.operatorCostIncluded,
        'operatorInsuranceIncluded': value.operatorInsuranceIncluded,
        'isApproved': value.isApproved,
        'isApprovedForSale': value.isApprovedForSale,
        'isMachineRemovedFromSale': value.isMachineRemovedFromSale,
        'fuelIncluded': value.fuelIncluded,
        'creationDate': value.creationDate === undefined ? undefined : (value.creationDate.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate.toISOString()),
        'createdUserId': value.createdUserId,
        'createdUserRole': value.createdUserRole,
        'bladeWidth': value.bladeWidth,
        'frequency': value.frequency,
        'minPower': value.minPower,
        'maxPower': value.maxPower,
        'maxLoadCapacity': value.maxLoadCapacity,
        'nominalCapacity': value.nominalCapacity,
        'waterTankCapacity': value.waterTankCapacity,
        'maxFeedingSize': value.maxFeedingSize,
        'workingSpeed': value.workingSpeed,
        'cleaningCapacity': value.cleaningCapacity,
        'garbageCollectionBin': value.garbageCollectionBin,
        'breakingInfo': value.breakingInfo,
        'bomLength': value.bomLength,
        'maxHeight': value.maxHeight,
        'maxDepth': value.maxDepth,
        'maxWidth': value.maxWidth,
        'compressionWidth': value.compressionWidth,
        'platformLength': value.platformLength,
        'platformWidth': value.platformWidth,
        'concretePumpingCapacity': value.concretePumpingCapacity,
        'maxPressure': value.maxPressure,
        'freeAirOutput': value.freeAirOutput,
        'spraySpeed': value.spraySpeed,
        'tankVolume': value.tankVolume,
        'loadCapacity': value.loadCapacity,
        'cameraResolutionId': value.cameraResolutionId,
        'flightTime': value.flightTime,
        'flightDistance': value.flightDistance,
        'workingRadius': value.workingRadius,
        'isMachineForSale': value.isMachineForSale,
        'machineSalePrice': value.machineSalePrice,
        'machineSalePriceCurrencyId': value.machineSalePriceCurrencyId,
        'machineLocationCityId': value.machineLocationCityId,
        'rentalAdTitle': value.rentalAdTitle,
        'saleAdTitle': value.saleAdTitle,
        'lessorCompany': BasicModelToJSON(value.lessorCompany),
        'subCategory': SubCategoryModelToJSON(value.subCategory),
        'brand': BasicModelToJSON(value.brand),
        'fuelType': BasicModelToJSON(value.fuelType),
        'elevatorType': BasicModelToJSON(value.elevatorType),
        'cameraResolution': BasicModelToJSON(value.cameraResolution),
        'machineLocationCity': BasicModelToJSON(value.machineLocationCity),
        'machineSaleDetail': MachineSaleDetailModelToJSON(value.machineSaleDetail),
        'machineRentalDetail': MachineRentalDetailModelToJSON(value.machineRentalDetail),
        'rentalTypes': value.rentalTypes === undefined ? undefined : (value.rentalTypes === null ? null : (value.rentalTypes as Array<any>).map(MachineRentalTypeModelToJSON)),
        'serviceRegions': value.serviceRegions === undefined ? undefined : (value.serviceRegions === null ? null : (value.serviceRegions as Array<any>).map(BasicModelToJSON)),
        'documents': value.documents === undefined ? undefined : (value.documents === null ? null : (value.documents as Array<any>).map(MachineDocumentViewModelToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(BasicModelToJSON)),
    };
}

